exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".section {\n  border-radius: 5px;\n  width: 99%;\n  background: linear-gradient(to bottom right, white, #d2dcff);\n  padding: 5px;\n  padding-top: 10px;\n  margin-bottom: 3px;\n  color: black; }\n\n.sectionHeader {\n  font-size: normal;\n  font-weight: bolder; }\n\n.sectionDescription {\n  font-size: smaller;\n  margin-left: 20px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/thunder/git/portfolier/src/app/+cv/common.scss
// module id = ../../../../../src/app/+cv/common.scss
// module chunks = 1